var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDianti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_18781)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_18781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H15.5V16H0.5V0Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6L5 3H10L9.5 11L7 14H1V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6L5 3H10M1 6H7M1 6V14H7M10 3L7 6M10 3L9.5 11L7 14M7 6V14",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6L10 3H15V11L13.5 14H7V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6L10 3H15M7 6H13.5M7 6V14H13.5M15 3L13.5 6M15 3V11L13.5 14M13.5 6V14",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5V13.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5V13.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5V0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16V14",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_18781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_18781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianti);
export default __webpack_public_path__ + "static/media/dianti.fc3669876146b86af69e09399bc36f2d.svg";
export { ForwardRef as ReactComponent };